import type { State, Filters } from '../../../../common/types.tsx';

export const getFilters = (state: State): Filters => state.filters;
